<template>
  <div
    v-if="isDataExist"
    class="funds-block__wrapper"
  >
    <div class="funds-block__title">
      Funds
    </div>
    <div class="funds-block__section">
      <div
        v-if="incomingSources.length"
        class="funds-block__content-wrapper"
      >
        <div class="funds-block__sub-title">
          Received From
        </div>
        <div class="funds-block__content">
          <GlBadgeInfo
            v-for="item in incomingSources"
            :key="item._id || item.tagId"
            :text="item.funds.name"
            :value="item.funds.score ?? -1"
          />
        </div>
      </div>
      <div
        v-if="outgoingSources.length"
        class="funds-block__content-wrapper"
      >
        <div class="funds-block__sub-title">
          Sent To
        </div>
        <div class="funds-block__content">
          <GlBadgeInfo
            v-for="item in outgoingSources"
            :key="item._id || item.tagId"
            :text="item.funds.name"
            :value="item.funds.score ?? -1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import GlBadgeInfo from '@/components/gl-badge-info'

export default {
  name: 'FundsBlock',
  components: { GlBadgeInfo },
  props: {
    incomingSources: {
      type: Array,
      default: () => [],
    },
    outgoingSources: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isDataExist() {
      return this.incomingSources.length || this.outgoingSources.length || true
    },
  },
}
</script>
<style scoped>
.funds-block__wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.funds-block__title {
  font-family: var(--Family-Montserrat, Montserrat);
  font-size: var(--Size-2XL, 20px);
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 28px);
}
.funds-block__sub-title {
  font-size: var(--Size-L, 16px);
  font-weight: 700;
  line-height: var(--Line-Height-XL, 24px);
}
.funds-block__section {
  display: flex;
  gap: 24px;
}
.funds-block__content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.funds-block__content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 1023px) {
  .funds-block__section {
    flex-direction: column;
  }
}
</style>
